export default {
      id: "arrowLeft-usage",
      viewBox: "0 0 53 28",
      url: "../../assets/" + "sprite.svg#arrowLeft-usage",
      toString: function () {
        return this.url;
      }
    }